
export const DEFAULT_PAGE_SIZE = 50;
export const DATA_GRID_LOADING_INDICATOR_HEIGHT_WIDTH = 100;
export const MAX_VALUE_INT_DOTNET = 2147483647;
export const DEFAULT_EXPORT_BATCH_SIZE = 500;
export const COLUMN_SIZE = {
    sm: 25,
    sm0: 50,
    sm1: 75,
    md0: 100,
    md1: 150,
    lg0: 190,
    lg1: 200,
    lg2: 270,
    xl: 300,
    xl0: 330,
    MatchTypeField: 80,
    ProductGrupField: 80,
    ProductCodeField: 190,
    QuantityField: 125,
    PriceField: 150,
    Description: 330,
    LongDescription: 360,
    ReferenceField: 200,
};
export const NumberOfDecimalPlaces = 2;
export const GRID_HEIGHT_OFFSET = {
    withFilter: 300,
    withoutFilter: 240
};
export const Patterns = {
    positiveTwoDecimalValue: {
        type: 'pattern',
        message: 'Enter a positive value.',
        pattern: /^\d*\.?\d+$/,
    }
};
